export const convertBuiltCampaignComponentResponseToBuiltComponentResponse = (campaignId, campaignState, builtCampaignComponent) => {
    return {
        id: builtCampaignComponent.id,
        campaign_id: campaignId,
        campaign_state: campaignState,
        owner: "CLIENT",
        component_version: builtCampaignComponent.component_version,
        name: builtCampaignComponent.name,
        display_name: builtCampaignComponent.display_name,
        type: builtCampaignComponent.type,
        description: builtCampaignComponent.description,
        tags: builtCampaignComponent.tags,
        variables: builtCampaignComponent.variables,
        assets: builtCampaignComponent.assets,
        component_ids: builtCampaignComponent.component_ids,
        created_date: builtCampaignComponent.created_date,
        updated_date: builtCampaignComponent.updated_date,
        absolute_names: builtCampaignComponent.absolute_names,
        installed_into_socket: builtCampaignComponent.installed_into_socket,
    };
};
